<template>
    <div>
        
        <table class="table table-condensed">
            <thead>
                <tr>
                    <th v-if="product.photo_link">Obraz</th>
                    <th>Nazwa</th>
                    <th>Cena</th>
                    <th>Kategoria</th>
                    <th>Brand</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td v-if="product.photo_link">
                        <div class="photo-preview">
                            <img v-bind:src="product.photo_link" class="img-responsive" />
                        </div>
                    </td>
                    <td>
                        <a v-bind:href="product.url" target="_blank">{{ product.name }}</a>
                    </td>
                    <td>{{ product.price }}</td>
                    <td>{{ product.category_name }}</td>
                    <td>{{ product.brand }}</td>
                </tr>
            </tbody>
        </table>
        <hr />
        
        <div class="details">
            <!--<product-details></product-details>-->
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
//    import ProductDetails from './ProductDetails.vue'

//    let ProductDetailsLoader = Vue.extend(ProductDetails)
    
    export default {
        name: 'Product',
        props: ["id"],
        data() {
            return {
                product: {}
            } 
            
        },
        components: {
//            ProductDetails
        },
        mounted() {
            this.update();
        },
        methods: {
            update() {                
                let v = this;
                
                v.$http.get('products/info/' + v.id).then((response) => {
                    v.product = response.body;
                })
                
//                v.$http.get('reports/details', {params: {id: v.id}}).then((response) => {
//                    new ProductDetailsLoader({data: response.body}).$mount($('.details')[0])
//                })      
            }
        },
        watch: {
            id: {
                handler: function (newData, oldData) {
                    this.id = newData;
                    this.update();
                }
            }
        }
    }
</script>

<style>
    .photo-preview {
        max-width: 150px;
    }
</style>


// WEBPACK FOOTER //
// Product.vue?316b70c9